var _defs, _polygon, _path, _path2, _path3, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelingVolumesSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#363545;}.cls-3{fill:#aeaeb6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingVolumes_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.5 26.68 16.44 26.72 15.88 27 15.5 26.81 15.32 26.72 14.76 26.44 8.12 23.12 6.35 24 16 28.79 25.65 24 23.76 23.06 17 26.44 16.5 26.68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.72,7.29a17.29,17.29,0,0,1-10,.27,20.86,20.86,0,0,1-2.4-1C15.18,6,14.54,5.77,14,6s-.6.5-.93,1.38a5.92,5.92,0,0,1-1.84,2.84,6.16,6.16,0,0,1-2.64,1.13l2.12,1.05c2.32-2.23,4.5-3.27,6.49-3.07a8,8,0,0,1,2.46.77,7.82,7.82,0,0,0,3.39.85h0a7.53,7.53,0,0,0,1.56-.17L30.16,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.82,11.91A6.41,6.41,0,0,0,17,11.3c-1.26-.12-2.73.56-4.38,2L16,15l4.79-2.38A12.62,12.62,0,0,1,18.82,11.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.94,8.63a4.13,4.13,0,0,0,1.22-2A3.69,3.69,0,0,1,13.28,4.1c1.37-.5,2.61.07,3.91.67a19.12,19.12,0,0,0,2.17.88,13.85,13.85,0,0,0,6.56.25L16,1,1.84,8,4.61,9.37C7.09,9.72,8.88,9.47,9.94,8.63Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.5 26.68 16.44 26.72 15.88 27 15.5 26.81 15.32 26.72 14.76 26.44 8.12 23.12 6.35 24 16 28.79 25.65 24 23.76 23.06 17 26.44 16.5 26.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24 20.96 24 13.44 16.5 17.18 16.5 17.25 17.13 17.57 24 20.96"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.5 25.57 22.64 22.5 23.74 21.95 16.5 18.37 16.5 25.57"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.24 22.57 15.5 25.69 15.5 18.37 8.13 22.01 9.24 22.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.45 17.28 8 13.56 8 20.96 14.87 17.57 15.45 17.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25 21.44 25 21.88 25 22.44 24.87 22.51 24.87 22.51 24 22.94 23.76 23.06 25.65 24 16 28.79 6.35 24 8.12 23.12 8 23.06 7 22.56 7 22 7 21.45 7 21.44 1.84 24 16 31.02 30.16 24 25 21.44"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.74 21.95 24 21.82 24 21.29 24 20.96 17.13 17.57 16.5 17.25 16.5 18.37 23.74 21.95"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7 22.57 7.01 22.57 7 22.56 7 22.57"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "8 21.95 8.13 22.01 15.5 18.37 15.5 17.3 15.45 17.28 14.87 17.57 8 20.96 8 21.29 8 21.95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,12.32l-7.5,3.75-.62.31-.38-.19L8,12.44,7,12v9.49H7v1.1H7l1,.49.12.06,6.64,3.32.56.28.18.09.38.18.56-.27.06,0,.5-.24,6.76-3.38.24-.12.87-.43.13-.07V11.82ZM15.5,25.69,9.24,22.56,8.13,22,8,22V13.56l7.45,3.72.05,0v8.38ZM24,21.28v.54l-.26.13-1.1.55L16.5,25.57V17.18L24,13.44v7.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingVolumesSvg);
export default __webpack_public_path__ + "static/media/ModelingVolumes_svg.6d8d25264f855bdade8506851bb8006e.svg";
export { ForwardRef as ReactComponent };